module.exports = __webpack_public_path__ + "static/1-e70c3865bb28ab090a3282721a1819c8.png";